module.exports = __webpack_public_path__ + "static/media/jtoutreachhead.f57cadfb.jpg";